import React from "react";

import Button from "components/Button";
import UsageBar from "components/UsageBar";
import TopButtons from "../TopButtons";

import VoltaSmallWhiteIcon from "assets/images/icons/VoltaSmallWhiteIcon.svg";

import classes from "./styles.module.scss";

const CommunityRunCapacityHeader = ({
    readOnly = false,
    currentTab,
    availableRuns = 0,
    runsUsedTotal = 0,
    runsToBeUsed = 0,
    onUnlockRunsClick,
}) => (
    <div className={classes.capacityHeader}>
        <div className={classes.capacityRow}>
            <span className={classes.creditsText}>Unlocked runs: {Number(availableRuns || 0).toLocaleString()}</span>
            {!readOnly && (
                <Button
                    icon={() => <img src={VoltaSmallWhiteIcon} alt="Volta" />}
                    onClick={onUnlockRunsClick}
                >
                    Unlock Runs
                </Button>
            )}
            <TopButtons currentTab={currentTab} readOnly={readOnly} />
        </div>
        <UsageBar
            usage={runsUsedTotal}
            toBeUsed={runsToBeUsed || 0}
            total={availableRuns}
            mainColor="#18C1AD"
            secondaryColor="#FFB22D"
            showDetails
        />
    </div>
);

export default CommunityRunCapacityHeader;
